import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}> 
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function AppliqueDigitizing() {

    const appliqeuSteps = [
        { number: "01", title: "Submit Your Design", description: "Send your logo or artwork in JPG, PNG, PDF, or AI format.", icon: "📤" },
        { number: "02", title: "Applique Digitizing", description: "We convert your design into a machine-ready stitch file optimized for applique embroidery.", icon: "⚡" },
        { number: "03", title: "Quality Optimization", description: "We refine stitch paths, layers, and density for perfect embroidery results.", icon: "✓" },
        { number: "04", title: "File Delivery", description: "Receive your embroidery files in DST, PES, JEF, and other compatible formats.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Applique Embroidery Digitizing Services Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Expert applique embroidery digitizing services in Los Angeles, CA. Get high-quality applique stitch files for logos and designs." />
                <meta name="keywords" content="applique digitizing, applique embroidery digitizing, applique logo digitizing, embroidery digitizing Los Angeles, applique services near me" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Applique Digitizing</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Applique Digitizing</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/applique1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Texture. Depth. Creative Impact.</span>
                                <h3 className="case-study-title">Professional Applique Digitizing Services in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we provide specialized applique embroidery digitizing services in Los Angeles, California, helping businesses and designers create stunning embroidered designs using fabric overlays. Applique embroidery requires precise digitizing to ensure every layer of fabric is accurately stitched, maintaining clean edges and professional results.
                                </p>
                                <p className="case-study-description">
                                    Our team carefully converts logos, artwork, and custom designs into machine-ready stitch files optimized for applique applications. Whether your design involves simple shapes, detailed patterns, or layered elements, our applique digitizing services ensure your embroidery looks polished and visually appealing. If you’re searching for reliable applique digitizing near you in Los Angeles, Grand Indigo Embroidery delivers precision, consistency, and high-quality results every time.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Structured for Seamless Fabric Application</span>
                                <h3 className="case-study-title">Custom Applique Digitizing for Logos & Designs</h3>
                                <p className="case-study-description">
                                    Our custom applique digitizing services are tailored for businesses, schools, sports teams, and fashion designers who want unique and creative embroidery designs. Each file is optimized for fabric type, placement, and embroidery machine requirements, ensuring minimal thread breaks and perfect layering.
                                </p>
                                <p className="case-study-description">
                                    From small logos to large decorative designs, we provide fully production-ready embroidery files. Businesses in Los Angeles trust Grand Indigo Embroidery for fast turnaround, accurate applique digitizing, and professional results. You can also order applique embroidery digitizing online for quick, convenient service.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/applique2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={appliqeuSteps} />
                                                
            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What is applique embroidery digitizing?"
                                    answer="Applique embroidery digitizing is the process of converting designs into machine-readable stitch files for embroidery that uses fabric overlays for added texture and dimension."
                                />

                                <FaqItem
                                    question="Do you offer applique digitizing services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery provides professional applique digitizing services in Los Angeles, California for local and online clients."
                                />

                                <FaqItem
                                    question="Can I order applique digitizing online?"
                                    answer="Absolutely. You can easily order applique embroidery digitizing online and receive optimized files quickly."
                                />

                                <FaqItem
                                    question="What types of designs work best for applique embroidery?"
                                    answer="Applique works best with bold shapes, letters, logos, and layered designs that benefit from fabric overlays.    "
                                />

                                <FaqItem
                                    question="What garments can use applique embroidery?"
                                    answer="Applique embroidery can be applied to jackets, hats, uniforms, shirts, and decorative apparel."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
